import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class DataService {

  private static data = {};

  public static get(key: string) {
    return DataService.data[key] || null;
  }

  public static set(key: string, value: any) {
    DataService.data[key] = value;
  }

  public static delete(key: string) {
    DataService.data[key] = undefined;
  }

  public static deleteAll() {
    DataService.data = {};
  }


}
